import {
  IOfferingSearchFilterEnum,
  IOfferingSearchSortEnum,
} from '@r-client/data/graphql-types';
import { IGrowthStageOfferingsQueryVariables } from '@r-client/republic/data/offerings';

export const HEADING = 'Open offerings';

/**
 * Larger than `DEAL_RAIL_SLIDE_WIDTH`'s 348px default: the homepage's design
 * gives this rail's cards more room (416px at `sm`) than funded ventures on
 * /investment-opportunities gets.
 */
export const GROWTH_STAGE_RAIL_SLIDE_WIDTH = { base: '17.5rem', sm: '26rem' };

export const SUBHEADER =
  'Funds, businesses, real estate, culture assets, and more.';

export const EMPTY_MESSAGE = 'No growth stage ventures right now.';

/**
 * Must differ from any other `role="status"` label on the homepage: two live
 * regions sharing a name are ambiguous to assistive tech and to `getByRole`.
 */
export const LOADING_LABEL = 'Loading growth stage ventures';

/** One rail-length of cards. The rail is not paginated. */
export const GROWTH_STAGE_RAIL_PAGE_SIZE = 8;

/**
 * How many of them survive the mobile stack, per the design. The rest — and the
 * rail's terminating tile — are hidden below `md`; see
 * `ICardRailProps.mobileCount`.
 */
export const MOBILE_CARD_COUNT = 3;

/**
 * The /investment-opportunities grid's default view — every live deal, most
 * trending first — which is what the block's "See all" leads to.
 *
 * Spelled out rather than built with that page's `buildGrowthStageSearchParams`:
 * the helper exists to fold in the sector chips and the sort menu, and this rail
 * has neither.
 *
 * Module-level rather than built per render: `useQuery` re-runs `setVariables`
 * whenever the *identity* of this object changes, and nothing here depends on
 * props or state.
 */
export const GROWTH_STAGE_RAIL_QUERY_VARIABLES: IGrowthStageOfferingsQueryVariables =
  {
    first: GROWTH_STAGE_RAIL_PAGE_SIZE,
    searchParams: {
      filter: IOfferingSearchFilterEnum.Live,
      sort: IOfferingSearchSortEnum.Trending,
    },
  };
